import React from 'react';

function Team() {
  return (
    <div className="swiper-slide">
      <section className="section tc-team-style8">
        <div className="container">
          <div className="section-head mb-4 mb-lg-0">
            <h3 className="fsz-30 fw-600 text-uppercase">
              our <br /> experts
            </h3>
          </div>
          <div className="section-body">
            <div className="members">
              <div className="row">
                <div className="col-lg-2">
                  <div className="member-colmn">
                    <a href="#" className="team-card">
                      <div className="img">
                        <img
                          src="/home8_portfolio/assets/img/team/5.png"
                          alt=""
                          className="img-cover"
                        />
                      </div>
                      <h5 className="title"> Robert D. </h5>
                    </a>
                    <a href="#" className="team-card">
                      <div className="img">
                        <img
                          src="/home8_portfolio/assets/img/team/2.png"
                          alt=""
                          className="img-cover"
                        />
                      </div>
                      <h5 className="title"> Robert D. </h5>
                    </a>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="member-colmn">
                    <a href="#" className="team-card">
                      <div className="img">
                        <img
                          src="/home8_portfolio/assets/img/team/3.png"
                          alt=""
                          className="img-cover"
                        />
                      </div>
                      <h5 className="title"> Robert D. </h5>
                    </a>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="member-colmn">
                    <a href="#" className="team-card">
                      <div className="img">
                        <img
                          src="/home8_portfolio/assets/img/team/4.png"
                          alt=""
                          className="img-cover"
                        />
                      </div>
                      <h5 className="title"> Robert D. </h5>
                    </a>
                    <a href="#" className="team-card">
                      <div className="img">
                        <img
                          src="/home8_portfolio/assets/img/team/5.png"
                          alt=""
                          className="img-cover"
                        />
                      </div>
                      <h5 className="title"> Robert D. </h5>
                    </a>
                  </div>
                </div>
                <div className="col-lg-2 order-last order-lg-0">
                  <div className="member-colmn">
                    <a href="#" className="team-card">
                      <div className="img">
                        <img
                          src="/home8_portfolio/assets/img/team/6.png"
                          alt=""
                          className="img-cover"
                        />
                      </div>
                      <h5 className="title"> Robert D. </h5>
                    </a>
                    <a href="#" className="team-card team-text">
                      <div className="img">
                        <h5 className="title">
                          <div className="con">
                            <span>
                              See All Our <br /> Member
                            </span>
                            <span className="arrow">
                              <i className="fal fa-arrow-up-right"></i>
                            </span>
                          </div>
                        </h5>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="member-colmn">
                    <a href="#" className="team-card">
                      <div className="img">
                        <img
                          src="/home8_portfolio/assets/img/team/7.png"
                          alt=""
                          className="img-cover"
                        />
                      </div>
                      <h5 className="title"> Robert D. </h5>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <a
              href="#"
              className="butn border rounded-pill border-white hover-bg-orange1 text-capitalize text-white mt-20 fsz-13 pt-15 pb-15"
            >
              <span> Become Our Member </span>
            </a>
            <span className="num mt-40 d-block"> 06 </span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Team;
